// extracted by mini-css-extract-plugin
export default {"content":"Permissions_content__7byxq","subtitle":"Permissions_subtitle__OxrH8","firstGroup":"Permissions_firstGroup__JX7It","bottomBorderDiv":"Permissions_bottomBorderDiv__-vNIo"};